import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import {loginUserSession,getApplicationState} from "./redux/actions";
import { IntlProvider } from 'react-intl';
import './helpers/Firebase';
import cookie from 'react-cookies';
import AppLocale from './lang';
import ColorSwitcher from './components/common/ColorSwitcher';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import { isMultiColorActive, isDemo } from './constants/defaultValues';
import { getDirection } from './helpers/Utils';

const ViewMain = React.lazy(() =>
  import(/* webpackChunkName: "views" */ './views')
);
const ViewApp = React.lazy(() =>
  import(/* webpackChunkName: "views-app" */ './views/app')
);
const ViewUser = React.lazy(() =>
  import(/* webpackChunkName: "views-user" */ './views/user')
);
const ViewError = React.lazy(() =>
  import(/* webpackChunkName: "views-error" */ './views/error')
);

const ViewDowntime = React.lazy(() =>
  import(/* webpackChunkName: "views-error" */ './views/user')
);


const AuthRoute = ({ component: Component, authUser, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        authUser || isDemo ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/user/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }

  render() {
    const { locale, loginUser, company,activeState } = this.props;
    
    var prms = {uri:"applicationState",obj:{account:"analytics"}};
    if (activeState == 'unknown'){
    this.props.getApplicationState(prms);
    }
    const currentAppLocale = AppLocale[locale];
    const companyCode = cookie.load('companyCode');
    var userSession = cookie.load('_sid');
    userSession = (userSession !== "-1")?userSession:false;
    const hero = (company)?company.hero:false;
    var expires = new Date()
    var cc = (companyCode)?companyCode:company.domain;
   
    expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14)
    var _sid = (userSession)?userSession:this.props._sid;
    if (this.props.loginError){
          expires = new Date();
    expires.setDate(Date.now() - (1000 * 60 * 60 * 24 * 14))
     cookie.save(
          '_sid',
          -1,
          {
            path: '/',
            expires,
          }
        )
    }else{
    if (_sid && !loginUser){
      var _params = {uri:"login",obj:{session:_sid,account:"analytics"}};
      this.props.loginUserSession(_params);
    }else{
      if (!userSession && _sid){
        cookie.save(
          '_sid',
          _sid,
          {
            path: '/',
            expires,
          }
        )
      }
    }
}
    if (company && company.domain){
      cookie.save(
        'companyCode',
        cc,
        {
          path: '/',
          expires,
        }
      )
    }

    var hasUser = (loginUser)?loginUser:_sid;
    hasUser = (this.props.loginError && this.props.loginError === "Invalid Login")?false:hasUser;
    return (
      <div className="h-100">
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <React.Fragment>
            <NotificationContainer />
            {isMultiColorActive && <ColorSwitcher />}
            <Suspense fallback={<div className="loading" />}>
              <Router>
                {!this.props.activeState &&  <Redirect to="/user/downtime" />}
                <Switch>
                  <AuthRoute
                    path="/app"
                    authUser={hasUser}
                    component={ViewApp}
                    formError={this.props.error} 
                    activeState={this.props.activeState}
                  />
                  <Route
                    path="/user"
                    render={props => <ViewUser hero={hero} activeState={this.props.activeState} companyCode={companyCode} {...props} />}
                  />
                  <Route
                    path="/error"
                    exact
                    render={props => <ViewError {...props} />}
                  />
                  <Route
                    path="/"
                    exact
                    render={props => <ViewMain {...props} />}
                  />
                  <Redirect to="/error" />
                </Switch>
              </Router>
            </Suspense>
          </React.Fragment>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, settings }) => {
  const { user: loginUser, company: company,error,activeState } = authUser;
  const { _sid,loginError } = authUser;
  const { locale } = settings;
  return { loginUser, locale, company,_sid,loginError,error,activeState};
};
const mapActionsToProps = {};

export default connect(
  mapStateToProps,
  {
    loginUserSession,
    getApplicationState
  },
)(App);
